import * as moment from 'moment';
// import moment from 'moment';
//import moment from 'moment/src/moment';
import { IDateFormatHelper } from './IDateFormatHelper';
import { DateFormat } from './DateFormat';

export class DateFormatHelper implements IDateFormatHelper {
    format(duration: moment.Duration): DateFormat {
        const result = new DateFormat();
        const days = duration.asDays();
        if (days <= 3) {
            result.format = '%Y-%m-%d %H:%M';
            result.length = 16;
        } else if (days <= 180) {
            result.format = '%Y-%m-%d';
            result.length = 10;
        } else {
            result.format = '%Y-%m';
            result.length = 7;
        }
        return result;
    }

    getTickCounts(formatLength: number, width: number): number {
        const result = Math.floor(width / ((formatLength * 6) + 2));
        return result;
    }

    getTicks(domain: [Date, Date], width: number, duration: moment.Duration, formatLength: number) {
        const ticksCount = this.getTickCounts(formatLength, width);
        const beginMoment = moment(domain[0]);
        const endMoment = moment(domain[1]);
        let intervalDuration: moment.Duration;
        let interval: number;
        switch (formatLength) {
            case 16:
                //hours are displayed
                interval = Math.ceil(duration.asHours() / ticksCount);
                intervalDuration = moment.duration(interval, 'h');
                break;
            case 10:
                interval = Math.ceil(duration.asDays() / ticksCount);
                intervalDuration = moment.duration(interval, 'd');
                break;
            case 7:
                interval = Math.ceil(duration.asMonths() / ticksCount);
                intervalDuration = moment.duration(interval, 'M');
                break;
            case 3:
                interval = Math.ceil(duration.asMonths() / (3 * ticksCount));
                intervalDuration = moment.duration(interval, 'M');
                break;
            default:
                throw ('Unknown format');
        }
        const ticks: Date[] = [];
        let currentMoment = beginMoment;
        let i = 0;
        while (currentMoment < endMoment && (i <= ticksCount)) {
            ticks.push(currentMoment.toDate());
            currentMoment = currentMoment.clone().add(intervalDuration);
            i++;
        }
        return ticks;
    }
}